import {walkAllMetaComponents} from "@/components/common/controlBar/controlBarDialog/metaComponent/utils.js";
import {
  isLanguagePackageType
} from "@/components/common/controlBar/controlBarDialog/metaComponent/textInput/languagePackage.js";

function reWriteControllerKey(node, controller,  controllerKey){
  var matchedAction = getActionItem(node.actions, controllerKey)
  if(matchedAction){
    if(isObjectAction(matchedAction)){
      return createMetaComponentListUI(controllerKey, node, (()=>{
        var arr = []
        walkAllMetaComponents(controller, (walkedMetaComponent, key) => {
          if(key === controllerKey){
            arr.push(walkedMetaComponent)
          }
        })
        return arr
      })());
    }else{
      return controller[controllerKey]
    }
  }else{
    if(controller[controllerKey]){
      walkAllMetaComponents(controller, (walkedMetaComponent, key) => {
        if(key === controllerKey){
          walkedMetaComponent.isHide = true
        }
      })
      return controller[controllerKey]
    }else{
      return controller[controllerKey]
    }
  }

}


export function reBuildControllerByActions(controller, node){
  if(node.actions){
    if(controller.attribute){
      controller.attribute = reWriteControllerKey(node, controller, 'attribute')
    }
    if(controller.design){
      controller.design = reWriteControllerKey(node, controller, 'design')
    }
    if(controller.hover){
      controller.hover = reWriteControllerKey(node, controller, 'hover')
    }
    if(controller.playSet){
      controller.playSet = reWriteControllerKey(node, controller, 'playSet')
    }
  }
  return controller
}



export function isObjectAction(action){
  var res = false
  if(typeof action === 'object'){
     res = true
  }
  return res
}


export function getActionItem(actions, controllerKey){

  var matchedAction = actions.find((action)=>{
    if(isObjectAction(action)){
      return action&&action.name === controllerKey
    }else{
      return action === controllerKey
    }
  })
  return matchedAction
}


function getRemainingMetaComponentList(groupArr, metaComponentList){
  var exsitMetaComponentItems = []
  groupArr.forEach((groupItem )=>{
    groupItem.children.forEach((metaComponentItem)=>{
      exsitMetaComponentItems.push(metaComponentItem)
    })
  })
  var remainingMetaComponentList = metaComponentList.filter((metaComponentItem)=>{
    return !exsitMetaComponentItems.includes(metaComponentItem)
  })
  return [
    remainingMetaComponentList,
    exsitMetaComponentItems
  ]
}

export function createMetaComponentListUI(
  controllerKey,
  node,
  metaComponentList
){

  var matchedAction = getActionItem(node.actions, controllerKey)

  if((matchedAction && matchedAction.config)){
    return {
      isShowGroup: (()=>{
        if(isObjectAction(matchedAction)){
          if(Object.keys(matchedAction.config).length > 1){
            return {
              layout: matchedAction.groupLayout
            }
          }else{
            return false
          }
        }else{
          return false
        }
      })(),
      metaComponentList: (()=>{
        if(isObjectAction(matchedAction)){
          var groupArr = Object.keys(matchedAction.config).map((groupName)=>{
            return {
              title: groupName,
              children: (()=>{
                var res = matchedAction.config[groupName].map(englishTitle => {
                  var match = metaComponentList.find((metaComponentItem)=>{
                    return (
                      metaComponentItem.englishTitle === englishTitle
                    )
                  })

                  if(match){
                    match.isHide = false
                  }
                  return match
                }).filter((item)=>{
                  return item !== undefined
                })
                return res
              })()
            }
          })

          var [
            remainingMetaComponentList,
          ] = getRemainingMetaComponentList(groupArr, metaComponentList)
          if(remainingMetaComponentList && remainingMetaComponentList.length){
            remainingMetaComponentList.forEach((remainingMetaComponentItem)=>{
              remainingMetaComponentItem.isHide = true
            })
            groupArr.push({
              "title": "隐藏分组",
              type: 'hideGroup',
              "children": remainingMetaComponentList
            })
          }

          return groupArr
        }else{
          return [{
            title: '分组1',
            children: metaComponentList
          }]
        }
      })()
    }
  }else{
    return undefined
  }

}


